import { Box, Divider as MuiDivider, styled, Typography } from '@mui/material';

export const SubHeaderText = styled(Typography)(
  ({ theme }) => `
    font-size: 16px;
    font-weight: 300;
    color: '${theme.palette.brand.black}';
  `,
);

export const AlertContainer = styled(Box)`
  height: 100%;
  display: flex;
  align-items: flex-end;
`;

export const SubHeader = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
`;

export const Divider = styled(MuiDivider)`
  margin: 20px 0;
`;

export const Container = styled(Box)`
  margin: 20px 0;
  max-height: 30vh;
  overflow-x: scroll;
`;
